/*

ref rest:
https://github.com/airesvsg/acf-to-rest-api

contare elementi:
https://stackoverflow.com/questions/35562307/count-where-in-a-collection

endpoint
http://petrolinirent.dev/wp-json/petrolini/v1/auto/count/?contratto=8&tipo=9&range=900-800&marca=25&modello=26

*/

if (document.getElementById('ricercasoluzione')) {

  var currentLocation = window.location;
  var uri = currentLocation.origin;

  var url = currentLocation.href;
  var url = new URL(url);

  var paramVeicolo = (url.searchParams.get("veicolo")) ? url.searchParams.get("veicolo") : 0;
  var paramContratto = (url.searchParams.get("contratto")) ? url.searchParams.get("contratto") : 0;
  var paramTipo = (url.searchParams.get("tipo")) ? url.searchParams.get("tipo") : 0;
  var paramRange = (url.searchParams.get("range")) ? url.searchParams.get("range") : 0;
  var paramMarca = (url.searchParams.get("marca")) ? url.searchParams.get("marca") : 0;
  var paramModello = (url.searchParams.get("modello")) ? url.searchParams.get("modello") : 0;
  var paramCpage = (url.searchParams.get("cpage")) ? url.searchParams.get("cpage") : 1;
  var paramOfferta = (url.searchParams.get("offerta") == "true") ? true : false;
  var paramEmobility = (url.searchParams.get("emobility") == "true") ? true : false;

  var app = new Vue({
    el: '#ricercasoluzione',
    filters: {
      kmFilter: function(value) {
        var v = parseInt(value).toFixed(0).replace(/./g, function(c, i, a) {
          return i && c !== "." && ((a.length - i) % 3 === 0) ? ';' + c : c;
        });
        return v.replace(/\./g, '').replace(/;/g, '.');
      }
    },
    data: {
      base: {
        veicoli: false,
        contratti: false,
        tipi: false,
        range: false,
        marche: false,
        modelli: false
      },
      scelte: {
        veicolo: paramVeicolo,
        contratto: paramContratto,
        tipo: paramTipo,
        range: paramRange,
        marca: paramMarca,
        modello: paramModello,
        offerta: paramOfferta,
        emobility: paramEmobility
      },
      count: false,
      ready: false,
      auto: false,
      pagination: {
        perpage: 10,
        current: paramCpage
      },
      preferiti: false,
      allowchangeuri: true
    },

    computed: {
      notifica: function() {
        if (this.count === false) {
          return '<i class="fa fa-spinner fa-pulse fa-fw"></i> Attendi: stiamo cercando le soluzioni più adatte alla tua ricerca!';
        } else if (this.count === 0) {
          return 'Non sono state trovate soluzioni per la tua ricerca.';
        } else if (this.count === 1) {
          return 'È stata trovata una sola soluzione per la tua ricerca';
        } else {
          return 'Sono state trovate ' + this.count + ' soluzioni per la tua ricerca.';
        }
      },
      allerta: function() {
        if (this.count !== false && this.count <= 3) {
          return 'Se non hai trovato la soluzione più adatta alla tua esigenza di noleggio a ' +
            'lungo termine, fai una nuova ricerca modificando i campi del filtro oppure ' +
            '<a class="alert-link" href="/richiedi-un-preventivo-gratuito/">contattaci per ricevere una soluzione</a> ' +
            'altamente personalizzata e configurata alle tue esigenze.';
        }
        return false;
      },
      changeurl: function() {
        var base = currentLocation.pathname;
        return base +
          '?veicolo=' + this.scelte.veicolo +
          '&contratto=' + this.scelte.contratto +
          '&tipo=' + this.scelte.tipo +
          '&range=' + this.scelte.range +
          '&marca=' + this.scelte.marca +
          '&modello=' + this.scelte.modello +
          '&offerta=' + this.scelte.offerta +
          '&emobility=' + this.scelte.emobility +
          '&cpage=' + this.pagination.current;
      },
      shareurl: function() {
        return origin + this.changeurl;
      },
      totpage: function() {
        return _.ceil(this.count / this.pagination.perpage);
      }
    },

    watch: {
      "scelte.veicolo": function() {
        this.scelte.contratto = 0;
      },
      "scelte.marca": function() {
        this.getModelli();
      },
      scelte: {
        handler: function() {
          this.getCount();
          this.getAuto();
          this.changeUrl();
          this.pagination.current = 1;
        },
        deep: true
      },
      pagination: {
        handler: function() {
          this.getCount();
          this.getAuto();
          this.changeUrl();

          window.scrollTo(0, 0);
        },
        deep: true
      }
    },
    methods: {
      changeUrl: function() {
        if (currentLocation.pathname == '/ricerca-soluzione/') {
          console.log('Aggiorno url');
          window.history.pushState(this.scelte, "Ricerca soluzione", this.changeurl);
        } else {
          console.log('Non aggiorno url');
        }
      },
      getVeicoli: function() {
        this.$http.get(uri + '/wp-json/wp/v2/veicolo?per_page=100').then(function(response) {
          this.base.veicoli = _.keyBy(response.body, function(item) {
            return item.id;
          });
          console.log('Aggiornati veicoli');
        }, function(response) {
          console.log('Errore in getVeicoli');
        });
      },
      getContratti: function() {
        this.$http.get(uri + '/wp-json/wp/v2/contratto?per_page=100').then(function(response) {
          this.base.contratti = _.keyBy(response.body, function(item) {
            return item.id;
          });
          console.log('Aggiornati contratti');
        }, function(response) {
          console.log('Errore in getContratti');
        });
      },
      getTipi: function() {
        this.$http.get(uri + '/wp-json/wp/v2/tipo?per_page=100').then(function(response) {
          this.base.tipi = _.chain(response.body)
            .keyBy(function(item) {
              return item.id;
            })
            .sortBy(function(item) {
              return item.name;
            })
            .value();
          console.log('Aggiornati tipi');
        }, function(response) {
          console.log('Errore in getTipi');
        });
      },
      getRange: function() {
        this.$http.get(uri + '/wp-json/acf/v2/options/ranges').then(function(response) {
          this.base.range = _.keyBy(response.body.ranges, function(item) {
            return item.value;
          });
          console.log('Aggiornati range');
        }, function(response) {
          console.log('Errore in getRange');
        });
      },
      getMarche: function() {
        this.base.marche = false;
        this.$http.get(uri + '/wp-json/wp/v2/marca?parent=0&per_page=100').then(function(response) {
          this.base.marche = _.chain(response.body)
            .keyBy(function(item) {
              return item.id;
            })
            .sortBy(function(item) {
              return item.name;
            })
            .value();
          console.log('Aggiornate marche');
        }, function(response) {
          console.log('Errore in getMarche');
        });
      },
      getModelli: function() {
        this.$http.get(uri + '/wp-json/wp/v2/marca?per_page=100&hide_empty=1&parent=' + this.scelte.marca).then(function(response) {
          this.base.modelli = _.chain(response.body)
            .keyBy(function(item) {
              return item.id;
            })
            .sortBy(function(item) {
              return item.name;
            })
            .value();
          console.log('Aggiornati modelli');
        }, function(response) {
          console.log('Errore in getModelli');
        });
      },
      getCount: function() {
        console.log('Conto le auto...');
        this.count = false;
        this.$http.get(uri +
          '/wp-json/petrolini/v1/auto/count/' +
          '?veicolo=' + this.scelte.veicolo +
          '&contratto=' + this.scelte.contratto +
          '&tipo=' + this.scelte.tipo +
          '&range=' + this.scelte.range +
          '&marca=' + this.scelte.marca +
          '&modello=' + this.scelte.modello +
          '&offerta=' + this.scelte.offerta +
          '&emobility=' + this.scelte.emobility
        ).then(function(response) {
          this.count = response.body;
          this.ready = true;
        }, function(response) {
          console.log('Errore in getCount');
        });
      },
      getAuto: function() {
        console.log('Cerco le auto...');
        var endpoint = uri +
          '/wp-json/petrolini/v1/auto/list/' +
          '?veicolo=' + this.scelte.veicolo +
          '&contratto=' + this.scelte.contratto +
          '&tipo=' + this.scelte.tipo +
          '&range=' + this.scelte.range +
          '&marca=' + this.scelte.marca +
          '&modello=' + this.scelte.modello +
          '&offerta=' + this.scelte.offerta +
          '&emobility=' + this.scelte.emobility +
          '&cpage=' + this.pagination.current +
          '&ppage=' + this.pagination.perpage;
        console.log(endpoint);
        this.$http.get(endpoint).then(function(response) {
          this.auto = _.orderBy(response.body, ['acf.prezzo'], ['asc']);
        }, function(response) {
          console.log('Errore in getAuto');
        });
      },


      // pagination
      pageNext: function() {
        this.pagination.current = this.pagination.current + 1;
        return;
      },
      pagePrev: function() {
        this.pagination.current = this.pagination.current - 1;
        return;
      },
      hasNext: function() {
        return (this.pagination.current < this.totpage);
      },
      hasPrev: function() {
        return (this.pagination.current > 1);
      },

      // filtraggio contratto
      escludiContratto: function(contratto) {
        // controlla con field array contratto.acf.escludi
        var veicolo = this.scelte.veicolo;
        return _.find(contratto.acf.escludi, function(item) {
          return item == veicolo;
        });
      },

      // preferenze
      getPreferiti: function() {
        var endpoint = uri + '/wp-json/petrolini/v1/preferenze/list';
        this.$http.get(endpoint).then(function(response) {
          this.preferiti = response.body;
          console.log('Preferiti caricati');
        }, function(response) {
          console.log('Errore in getPreferiti');
        });
      },
      isInPreferenze: function(id) {
        var preferiti = this.preferiti;
        return _.find(preferiti, function(item) {
          return item == id;
        });
      },
      addToPreferenze: function(id) {
        console.log(id);
        var endpoint = uri + '/wp-json/petrolini/v1/preferenze/add';
        this.$http.post(endpoint, {
          idauto: id
        }).then(function(response) {
          this.getPreferiti();
        }, function(response) {
          console.log('Errore in addToPreferenze');
        });
      },
      remToPreferenze: function(id) {
        var endpoint = uri + '/wp-json/petrolini/v1/preferenze/rim';
        this.$http.post(endpoint, {
          idauto: id
        }).then(function(response) {
          this.getPreferiti();
        }, function(response) {
          console.log('Errore in addToPreferenze');
        });
      },
    },

    mounted: function() {
      this.getPreferiti();
      this.getVeicoli();
      this.getContratti();
      this.getTipi();
      this.getRange();
      this.getMarche();
      this.getCount();
      this.getAuto();

      if (this.scelte.marca || this.scelte.modello) {
        this.getModelli();
      }
    }

  });
}